import {
  ArrowForward,
  Insights,
  Inventory,
  NavigateNext,
  Place,
  RequestQuote,
  Warehouse
} from '@mui/icons-material';
import ButtonComponent from 'components/design-system/Button/Button';
import Heading from 'components/design-system/Heading/Heading';
import { RoleComponent } from 'components/design-system/Role/Role';
import { useEffect } from 'react';

const { default: Text } = require('components/design-system/Text/Text');

export const PreConfirmacion = ({ data, onContinuar }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div className="grid grid-cols-12">
        <div className="col-span-12 md:col-span-5 mb-6 md:mb-0">
          <div className="flex items-center justify-between gap-x-2 h-10">
            <Text type="label" className="mb-0 text-uv-secondary-0">
              SOLICITANTE
            </Text>
            <div className="hidden md:block border-t-2 border-uv-secondary-0 border-dashed w-full h-1 mt-0.5"></div>
            <ArrowForward className="hidden md:block text-uv-secondary-0 w-10 h-10 mr-2" />
          </div>
          <div className="border border-gray-300 rounded p-4 md:mr-12">
            <div className="relative pl-14 mb-8">
              <RoleComponent
                rol={data.solicitante.nombreRol.toLowerCase()}
                tipo="marcador"
                className="absolute left-0 top-0"
              />
              <Heading type="h3" className="mb-0">
                {data.solicitante.nombreEmpresa}
              </Heading>
              <Text>{data.solicitante.nombreRol.toUpperCase()}</Text>
            </div>
            <div>
              <div className="relative pl-14">
                <Place className="text-uv-secondary-10 w-8 h-8 absolute left-1 top-0" />
                <span className="mb-1 block font-secondary text-xs text-neutral-60 tracking-wider font-medium">
                  {data.solicitante.nombreSucursal.toUpperCase()}
                </span>
                <Text>
                  {data.solicitante.nombreVia}
                  {', '}
                  {data.solicitante.nombreComuna}
                  {', Región '}
                  {data.solicitante.nombreRegion}
                </Text>
              </div>
            </div>
          </div>
        </div>
        <div className="col-span-12 md:col-span-7">
          <div className="flex items-center justify-between gap-x-2 h-10">
            <Text type="label" className="mb-0 text-uv-secondary-0">
              SOLICITADO
            </Text>
          </div>
          <div className="border border-gray-300 rounded">
            <div className="p-4">
              <div className="relative pl-14 mb-4">
                <RoleComponent
                  rol="receptor"
                  tipo="marcador"
                  className="absolute left-0 top-0"
                />
                <Heading type="h3" className="mb-0">
                  {data.solicitado.nombreEmpresa}
                </Heading>
                <Text>Receptor</Text>
              </div>
              <div>
                {data.solicitado.sucursales.map((sucursal, index) => (
                  <div className="relative pl-14 mt-4" key={index}>
                    <Place className="text-uv-secondary-10 w-8 h-8 absolute left-1 top-0" />
                    <span className="mb-1 block font-secondary text-xs text-neutral-60 tracking-wider font-medium">
                      {sucursal.nombreSucursal}
                    </span>
                    <Text>
                      {sucursal.nombreVia}
                      {', '}
                      {sucursal.nombreComuna}
                      {', Región '}
                      {sucursal.nombreRegion}
                    </Text>
                  </div>
                ))}
              </div>
            </div>

            <div className="border-t border-gray-300 p-4">
              <Heading type="h4" className="mb-0">
                Administración de los siguientes recursos:
              </Heading>

              <ul className="p-0 mx-2">
                <li className="relative border-b py-4 flex flex-col sm:flex-row items-center gap-6 text-center sm:text-left">
                  <Inventory className="text-uv-primary-0" />
                  <div>
                    <Heading type="h5" className="mb-0">
                      Gestionar residuos y recursos
                    </Heading>
                    <Text>
                      El usuario autorizado podrá crear, editar, eliminar
                      residuos y recursos.
                    </Text>
                  </div>
                </li>
                <li className="relative border-b py-4 flex flex-col sm:flex-row items-center gap-6 text-center sm:text-left">
                  <Warehouse className="text-uv-primary-0" />
                  <div>
                    <Heading type="h5" className="mb-0">
                      Administrar sucursales
                    </Heading>
                    <Text>
                      El usuario autorizado podrá crear, editar, eliminar
                      sucursales.
                    </Text>
                  </div>
                </li>
                <li className="relative border-b py-4 flex flex-col sm:flex-row items-center gap-6 text-center sm:text-left">
                  <RequestQuote className="text-uv-primary-0" />
                  <div>
                    <Heading type="h5" className="mb-0">
                      Recursos adquiridos y/o declarados
                    </Heading>
                    <Text>
                      El usuario autorizado podrá crear, editar, eliminar
                      recursos adquiridos.
                    </Text>
                  </div>
                </li>
                <li className="relative py-4 flex flex-col sm:flex-row items-center gap-6 text-center sm:text-left">
                  <Insights className="text-uv-primary-0" />
                  <div>
                    <Heading type="h5" className="mb-0">
                      Configuración para generación de indicadores
                    </Heading>
                    <Text>
                      El usuario autorizado podrá editar la configuración para
                      generación de indicadores
                    </Text>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="absolute bottom-0 w-full shadow-md rounded-bl rounded-br bg-white px-10 py-4 border-t left-0">
        <div className="flex justify-between">
          <div></div>
          <ButtonComponent form="form" onClick={onContinuar}>
            Continuar
            <NavigateNext />
          </ButtonComponent>
        </div>
      </div>
    </>
  );
};
